import React, { ReactNode } from 'react';
import { Col, Row } from 'reactstrap';
import { Control } from 'react-hook-form';
import { UpsertEmailTemplateDto } from '../../../containers/EmailTemplates/SetupEmailTemplatePage/UpsertEmailTemplateDto';
import { FormFieldHeader } from '../../FormFieldHeader';
import { RichTextEditor } from '../../RichTextEditor';
import { EMAIL_TEMPLATE_VARIABLES } from '../../../containers/EmailTemplates/SetupEmailTemplatePage/Body/CopyVariables';
import { AreaRichTextComposer } from '../../RichTextEditor/composers/AreaRichTextComposer';
import { PasteVariablePlugin } from '../../RichTextEditor/plugins/PasteVariablePlugin';
import { UpdateStatePlugin } from '../../RichTextEditor/plugins/UpdateStatePlugin';
import { Size } from '../../../utils/types/Size';

interface PropTypes {
  control: Control<UpsertEmailTemplateDto, any>;
  template?: string;
  title?: string;
  colSize?: number;
  footer?: ReactNode;
  size?: Size;
  setHtml: (html: string) => void;
}

export function EmailTemplateInput(props: PropTypes) {
  return (
    <>
      <Row className='mt-3'>
        <Col xs={props.colSize || 9}>
          <>
            <FormFieldHeader
              fieldName={props.title || 'Body'}
              isRequired={true}
            />
            <RichTextEditor<UpsertEmailTemplateDto>
              formHookContext={{
                controllerName: 'template',
                formControl: props.control,
                required: true,
              }}
              render={(field) => (
                <AreaRichTextComposer
                  defaultEditorState={field.value as string}
                  placeholder='Insert Email Text'
                  onChangeHtml={props.setHtml}
                  onChangeJson={(value: string) => field.onChange(value)}
                  size={props.size || 'md'}
                  externalPlugins={[
                    <UpdateStatePlugin key={1} editorState={props.template} />,
                    <PasteVariablePlugin
                      key={2}
                      variables={Object.values(EMAIL_TEMPLATE_VARIABLES)}
                    />,
                  ]}
                />
              )}
            />
            <div className='d-flex mt-2'>{props.footer}</div>
          </>
        </Col>
      </Row>
    </>
  );
}
